import React from "react";

const PageContainer = ({ children, className = "", style }) => (
  <div
    className={`border uk-background-muted uk-padding-small border-radius-15 ${className}`}
    style={{
      display: "flex",
      flexDirection: "column",
      minHeight: 0,
      overflow: "hidden",
      boxSizing: "border-box",
      marginBottom: "var(--page-container-bottom-gap)",
      ...style,
    }}
  >
    {children}
  </div>
);

export default PageContainer;
